import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Savings } from "./savings.model";
import { Savingstransaction } from "../shared/savingstransaction.model";

@Injectable({
  providedIn: 'root'
})

export class SavingstransactionService {

 public selectedSavingsTransaction : Savingstransaction;
 public SavingsTransactionList : Savingstransaction[];
 public selectedSavings: Savings

  constructor(private httpClient: HttpClient) { }
  
  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDSavingstransaction(savingstransaction: Savingstransaction) {
 
    savingstransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    savingstransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    savingstransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    savingstransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    savingstransaction.CreatedDate  = new Date(JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]);
    savingstransaction.ModifiedDate = new Date(JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"]);

    let body = savingstransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/IUD', body, { headers: headers });
  }

  FetchSavingsTransactionByNo( savingstransaction : any) {

    this.selectedSavingsTransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavingsTransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavingsTransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavingsTransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedSavingsTransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/Fetch', body, { headers: headers });
  }

  // Print saving transaction by transaction Id. 
  FetchSavingsTransactionById( savingstransactionId : any) {
    this.selectedSavingsTransaction.Id = +savingstransactionId;
    this.selectedSavingsTransaction.ReportName = "SavingsTransactionReport"
    this.selectedSavingsTransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavingsTransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavingsTransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavingsTransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body =  this.selectedSavingsTransaction;

    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/Report', body, { headers: headers });
  }

  FetchSavingsTransactionList(IsAccrued: boolean = false){
    this.selectedSavingsTransaction = new  Savingstransaction();
    this.selectedSavingsTransaction.IsAccruedAmount = IsAccrued;
    this.selectedSavingsTransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavingsTransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavingsTransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavingsTransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
   
    let body =  this.selectedSavingsTransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/FetchList', body, { headers: headers });
  }

  FetchDepositNoList(){
    
    this.selectedSavings= new Savings();
    this.selectedSavings.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavings.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavings.EmployeeId =+ JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavings.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedSavings;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() +  'api/Savings/FetchList', body,{headers: headers});
  }

  FetchSavingsReceiptsList(){
    this.selectedSavingsTransaction = new  Savingstransaction();
    this.selectedSavingsTransaction.IsReceiptAmount = true;
    this.selectedSavingsTransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedSavingsTransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedSavingsTransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedSavingsTransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
   
    let body =  this.selectedSavingsTransaction;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/FetchList', body, { headers: headers });
  }

  // //  PrintloantransactionlistService is using to generate receipt.
  // FetchReportLoantransactionList(SavingsTransactionItem: any){

  //   // console.log(loanTransactionItem);
  //   // console.log(loanTransactionItem.TransactionNo);

  //   this.selectedSavingsTransaction.TransactionNo = + loanTransactionItem.TransactionNo;
  //   this.selectedSavingsTransaction.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
  //   this.selectedSavingsTransaction.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
  //   this.selectedSavingsTransaction.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
  //   this.selectedSavingsTransaction.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
  //   let body =  this.selectedSavingsTransaction;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/SavingsTransaction/Report', body, { headers: headers });
  // }

}
